import WhitePressLogos from './WhitePressLogos';

export default WhitePressLogos;
